// utils/autoConvertI18n.js
import { useTranslation } from "react-i18next";
import useWebsiteInfo from "../hook/useWebsiteInfo";
import {
  appName,
  appNameGD,
  webName,
  webNameGD,
  brandName,
  brandNameGD,
  chineseName,
  chineseNameGD,
  domainName,
  domainNameGD,
} from "../config";

export const useBrandI18n = (namespace) => {
  const { t } = useTranslation();
  const { isGD88 } = useWebsiteInfo();

  return (key, additionalProps = {}) => {
    let text = t(`${namespace}.${key}`);

    // 只有在 GD88 時才自動轉換
    if (isGD88) {
      // 自動將固定文字轉為插值格式
      text = text
        // 注意轉換順序
        .replace(/飛龍娛樂城/g, "{{currentWebName}}")
        .replace(/金仁娛樂城/g, "{{currentWebName}}")
        .replace(/https:\/\/ds88\.tw/g, "https://{{currentWebsiteUrl}}")
        .replace(/\bds88\.tw\b/g, "{{currentWebsiteUrl}}")
        .replace(/\bDS88\b/g, "{{currentBrandName}}")
        .replace(/\bds88\b/g, "{{currentAppName}}")
        .replace(/\b飛龍\b/g, "{{currentChineseName}}");
    }

    // 所有文字轉成插值格式 {{key}} 例如: 有翻譯是"飛龍" 會轉成{{currentChineseName}}
    const data = {
      currentWebName: isGD88 ? webNameGD : webName,
      currentAppName: isGD88 ? appNameGD : appName,
      currentBrandName: isGD88 ? brandNameGD : brandName,
      currentChineseName: isGD88 ? chineseNameGD : chineseName,
      currentWebsiteUrl: isGD88 ? `${domainNameGD}.tw` : `${domainName}.tw`,
      ...additionalProps,
    };

    //文字中的變數換成對應的值 例如{{currentWebName}}會換成webNameGD
    return text.replace(/\{\{(\w+)\}\}/g, (match, key) =>
      data[key] !== undefined ? data[key] : match
    );
  };
};
